var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Safras" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputSelect", {
            attrs: {
              label: "Ano/Safra",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: _vm.rules,
              opcoes: [
                { id: "2021/22", nome: "2021/22" },
                { id: "2022/23", nome: "2022/23" },
                { id: "2023/24", nome: "2023/24" },
                { id: "2024/25", nome: "2024/25" },
                { id: "2025/26", nome: "2025/26" }
              ],
              widthColumn: 7,
              value: _vm.anoSafra
            },
            on: { input: _vm.updateAnoSafra }
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.praticasArray.length ? "area" : "",
              name: _vm.nomeAba + "/Área"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { staticClass: "ml-2", attrs: { span: 7 } },
                      [
                        _c("Label", {
                          attrs: { label: "Área", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("AppInputDouble", {
                          class: { erro: errors.length, input: "input" },
                          attrs: {
                            name: "Área",
                            precision: 2,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true,
                            value: _vm.areaDestinada
                          },
                          on: { input: _vm.updateAreaDestinada }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: _vm.rules,
              name: _vm.nomeAba + "/Previsão de colheita (mês/ano)"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      {
                        staticStyle: { "margin-left": "1rem" },
                        attrs: { span: 7 }
                      },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Data de início da prática de plantio",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          class: { "input erro": errors.length },
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "Selecione mês e ano",
                            format: "MM/yyyy",
                            "value-format": "yyyy-MM-dd",
                            value: _vm.dataInicio
                          },
                          on: { input: _vm.updateDataInicio }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-155ad9b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-155ad9b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/FormulariosProntos/Safras/Safras.vue
// module id = null
// module chunks = 